var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 6.45V8.55C4 10.3 4.7 11 6.45 11H8.55C10.3 11 11 10.3 11 8.55V6.45C11 4.7 10.3 4 8.55 4H6.45C4.7 4 4 4.7 4 6.45Z",
    fill: "#2B74DA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.44914 1H5.54914C6.88132 1 7.60217 1.40854 7.87061 2.37301C8.01994 2.90953 7.53915 3.375 6.98224 3.375H6.44914C4.34914 3.375 3.37414 4.35 3.37414 6.45V6.9831C3.37414 7.54001 2.90867 8.0208 2.37215 7.87147C1.40768 7.60303 0.99914 6.88218 0.99914 5.55V3.45C0.99914 1.7 1.69914 1 3.44914 1Z",
    fill: "#2B74DA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b74ccb8bb0b3bfeb012afc6ff4376dcf.svg";
export { ForwardRef as ReactComponent };